// ENG-2277 (HTML Forms): a digital Form (a TextTemplate) shown as a row in a surface's form picker.
import type { Practice } from "services/types/clinics.type";
import type { FormTemplate } from "services/types/form-templates.type";
import type { TextTemplate } from "services/types/text-templates.type";

/**
 * The picker row for a digital Form. Its id is the template's id negated, so it can never collide
 * with an Anvil form's id or the "Create my Custom Form…" sentinel, and its type is the surface's,
 * so surface code that branches on type sees the same value as for an Anvil row.
 */
export const toDigitalFormOption = (
  template: TextTemplate,
  practice: Practice,
  placement: number
): FormTemplate => ({
  id: -Number(template.id),
  text_template_meta: template,
  practice,
  type: placement,
  title: template.name,
  anvil_id: "",
  data_mapping: {}
});

/** A digital Form row. Anvil rows and "Create my Custom Form…" are not. */
export const isDigitalForm = (
  option: FormTemplate | null | undefined
): boolean => Boolean(option?.text_template_meta) && Number(option?.id) < 0;
